/* stylelint-disable selector-max-compound-selectors, max-nesting-depth */

sew-ws-podcast {
    &:not([no-grid]) {
        @include grid;
    }
    &:not([no-margin]) {
        @include component-spacing;
    }

    @include typo-ws-paragraph;

    display: block;

    button {
        all: unset;
        cursor: pointer;
    }

    > .teaser {
        display: grid;
        grid-template-columns: 1fr 2fr;
        grid-template-rows: min-content 1fr;
        column-gap: var(--column-gap);

        .picture {
            grid-area: 1 / 1 / 3 / 2;
            position: relative;

            .icon {
                position: absolute;
                left: 0;
                top: 0;
                width: 25%;
            }
        }

        .text {
            grid-area: 2 / 2 / 3 / 3;
        }

        .headline {
            @include typo-ws-h2;

            grid-column: 2;
            margin: 8px 0 0;
        }

        p {
            margin: 16px 0 0;
        }

        .audio {
            margin-top: 24px;
            display: flex;
            gap: 16px;
            align-items: center;

            .play-button {
                flex-shrink: 0;
            }
        }
    }

    .play-button {
        background-color: $color-red;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $color-white;

        [icon='media_play'] {
            transform: translateX(3px);
        }
    }

    .overlay {
        background-color: $color-grey-01-dark;
        color: $color-white;
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 4;
        transform: translate3d(0, calc(100% + 20px), 0);
        transition: transform 300ms;
        right: 0;
        padding: 24px 0;
        box-shadow: rgb(0 0 0 / 32%) 0 -4px 12px;

        &.visible {
            transform: translate3d(0, 0, 0);
        }

        .grid {
            @include grid;
        }

        .teaser {
            grid-column: 2 / span 4;
            display: flex;
            gap: 20px;
            align-items: center;

            slot[name='picture-thumb'] {
                display: block;
                width: 146px;
                flex-shrink: 0;
            }

            .headline {
                @include typo-ws-h4;

                margin: 0;
            }

            p {
                margin: 0;
            }
        }

        .controls {
            grid-column: 6 / -2;
            display: grid;
            grid-template-columns: repeat(3, min-content) 4fr repeat(2, min-content) 1fr;
            align-items: center;

            .rewind {
                margin-left: 40px;
                width: 32px;
            }

            .forward {
                margin-left: 24px;
                width: 32px;

                sew-icon {
                    transform: rotate(180deg);
                }
            }

            .progress {
                margin-left: 20px;
            }

            .time {
                @include typo-ws-paragraph-s;

                white-space: nowrap;
                margin-left: 10px;
            }

            .mute {
                margin-left: 17px;
                width: 24px;
            }

            .volume {
                margin-left: 5px;
            }
        }

        .close {
            position: relative;
            grid-column: -2;

            button {
                position: absolute;
                top: -9px;
                right: 15px;
            }
        }
    }

    &[columns='8'] {
        margin-top: 40px;

        > .teaser {
            grid-template-columns: 1fr 1fr;

            .headline {
                @include typo-ws-h4;

                margin: 0;
            }
        }
    }

    @media (width <= 1400px) {
        .overlay {
            .teaser {
                .text {
                    display: none;
                }
            }
        }
    }

    @include mq-1 {
        .play-button {
            width: 48px;
            height: 48px;

            sew-icon {
                transform: scale(0.8);
                transform-origin: center;
            }

            [icon='media_play'] {
                transform: scale(0.8) translateX(3px);
            }
        }

        > .teaser {
            display: block;

            .picture {
                margin-top: 24px;
            }

            .headline {
                margin: 0;
            }

            p {
                margin: 20px 0 0;
            }

            .audio {
                margin-top: 20px;
            }
        }

        .overlay {
            padding: 20px 0;

            .teaser {
                grid-column: 2 / span 4;

                slot[name='picture-thumb'] {
                    display: block;
                    width: 106px;
                    max-width: 100%;
                }
            }

            .controls {
                grid-column: 6 / -3;
                display: grid;
                grid-template-columns: 1fr min-content 1fr;
                align-items: center;

                .play-button {
                    justify-self: center;
                }

                .rewind,
                .forward,
                .time {
                    display: none;
                }

                .progress {
                    position: absolute;
                    top: -6px;
                    left: 0;
                    margin-left: 0;
                    width: 100%;

                    --track-bg-color: transparent;
                }

                .mute {
                    margin-left: 10px;
                }
            }

            .close {
                position: relative;

                button {
                    position: absolute;
                    top: -9px;
                    right: 11px;
                }
            }
        }
    }
}
